<template>
    <div class="business-content-main">
        <div class="bread-nav">
            <breadcrumb></breadcrumb>
        </div>
        <div class="tab-item-ctn">
            <div class="search-ctn">
                <div class="search-ctn-right">
                    <div class="search-name">部门</div>
                    <el-cascader
                        ref="orgCascader"
                        class="search-item"
                        v-model="searchData.OrgId"
                        :options="orgSearchData"
                        :props="cascaderProps"
                        size="small"
                        clearable
                        @change="getSIdData"
                        @visible-change="getOrgTree"
                    ></el-cascader>
                    <div class="search-name">采购员</div>
                    <el-select v-model="searchData.SIds" multiple collapse-tags size="small" class="search-item" filterable placeholder="请选择">
                        <el-option v-for="item in SIdList" :key="item.EmployeeId" :label="item.EmployeeName" :value="item.EmployeeId"></el-option>
                    </el-select>
                    <div class="search-name">提交时间</div>
                    <el-date-picker
                        v-model="dateTimes"
                        type="daterange"
                        align="right"
                        unlink-panels
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        :picker-options="pickerOptions"
                        @change="handleChange"
                        size="small"
                        class="search-name"
                    ></el-date-picker>
                    <div class="search-name">完成付款时间</div>
                    <el-date-picker
                        v-model="dateFTimes"
                        type="daterange"
                        align="right"
                        unlink-panels
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        :picker-options="pickerOptions"
                        @change="handleChangeFinishTime"
                        size="small"
                        class="search-name"
                    ></el-date-picker>
                    <div class="search-name">
                        <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="getPurchaseTableData">查询</el-button>
                        <el-button size="small" icon="el-icon-refresh" class="search-btn btn-primary" @click="resetSearch">重置</el-button>
                        <el-button size="small" class="search-btn btn-primary" v-if="permission.export" @click="exportData">
                            <i class="fa fa-file-excel-o"></i>
                            {{ permission.export }}
                        </el-button>
                    </div>
                </div>
            </div>
            <div class="table-ctn">
                <el-table
                    :header-cell-style="{ background: '#F2F6FC' }"
                    :data="tablePurchaseData"
                    border
                    style="width: 100%"
                    :default-sort="{ prop: 'SortNum', order: 'ascending' }"
                    :summary-method="getSummaries"
                    show-summary
                >
                    <el-table-column show-overflow-tooltip width="80px" type="index" sortable label="排名"></el-table-column>
                    <el-table-column show-overflow-tooltip min-width="100px" prop="OrgName" label="部门"></el-table-column>
                    <el-table-column show-overflow-tooltip min-width="100px" prop="SName" label="采购员"></el-table-column>
                    <el-table-column show-overflow-tooltip sortable min-width="110" prop="SaleTotalAmount" label="采购总额"></el-table-column>
                    <el-table-column show-overflow-tooltip sortable min-width="110" prop="SaleOrderTotalCount" label="采购单数"></el-table-column>
                    <el-table-column show-overflow-tooltip sortable min-width="110" prop="GoodsTotalCount" label="商品总数"></el-table-column>
                    <el-table-column show-overflow-tooltip sortable min-width="130" prop="SaleReturnTotalAmount" label="采购退货总额"></el-table-column>
                    <el-table-column show-overflow-tooltip sortable min-width="120" prop="SaleReturnTotalCount" label="采购退货数"></el-table-column>
                    <el-table-column show-overflow-tooltip sortable min-width="120" prop="SaleTotalCost" label="跟单总成本"></el-table-column>
                    <el-table-column show-overflow-tooltip sortable min-width="120" prop="SaleTotalProfit" label="跟单总利润"></el-table-column>
                    <el-table-column show-overflow-tooltip sortable min-width="140" prop="CusTotalCount" label="对接供应商数"></el-table-column>
                </el-table>
            </div>
        </div>
        <div style="z-index: 2001" class="exportmsg" v-if="showExportMsg">
            <span>数据已经准备好，正在生成Excel表格，可能耗时1-5min，请耐心等候……</span>
            <span>您也可以打开新的窗口进行其他的操作</span>
        </div>
    </div>
</template>
<script>
import breadcrumb from '@/components/common/breadcrumb';
import mixin from '@/mixins/mixin';
export default {
    mixins: [mixin],
    name: '',
    components: {
        breadcrumb
    },
    data() {
        return {
            dateTimes: [],
            dateFTimes: '',
            orgSearchData: [],
            searchData: {
                EntpId: this.$util.getLocalStorage('userMsg').EntpId,
                OrgId: '',
                SId: '',
                SIds: [],
                StartDate: '',
                EndDate: '',
                PayStartDate: '',
                PayEndDate: ''
            },
            cascaderProps: {
                emitPath: false,
                expandTrigger: 'hover',
                children: 'Childrens',
                label: 'Name',
                value: 'Id',
                checkStrictly: true
            },
            permission:{},
            SIdList: [],
            tableSaleData: [],
            tableSaleDataLength: 0,
            tablePurchaseData: [],
            tablePurchaseDataLength: 0,
            pickerOptions: {
                shortcuts: [
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近半年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ]
            }
        };
    },
    created() {
        //当前设定的日期时间
        let d = new Date();
        let year1, month1, day1;
        [year1, month1, day1] = [d.getFullYear(), d.getMonth(), d.getDate()];
        let date1 = new Date(year1, month1, day1, 0);
        this.dateTimes.push(date1);
        //前一天设定的日期时间
        let year2, month2, day2;
        d.setTime(d.getTime());
        [year2, month2, day2] = [d.getFullYear(), d.getMonth(), 1];
        let date2 = new Date(year2, month2, day2, 0);
        this.dateTimes.unshift(date2);

        this.searchData.StartDate = date2;
        this.searchData.EndDate = date1;
    },
    mounted() {
        this.permission = this.$util.getPermission('purchaseStat');
        this.$util.setEnterEvent(this, this.$route.fullPath);
        this.getPurchaseTableData();
    },
    methods: {
        renderHeader(h, { column }) {
            const serviceContent = [
                h(
                    'div',
                    {
                        slot: 'content',
                        style: 'margin-bottom:5px'
                    },
                    '销售总额的计算公式：'
                ),
                h(
                    'div',
                    {
                        slot: 'content'
                    },
                    '1、不包含已经删除及已经取消的销售单，'
                ),
                h(
                    'div',
                    {
                        slot: 'content'
                    },
                    '2、未减去售后部分的销售额。'
                )
            ];
            const paymentContent = h(
                'div',
                {
                    slot: 'content'
                },
                '货款 = 券后价 * 销量'
            );
            return h('span', [
                h(
                    'el-tooltip',
                    {
                        props: {
                            placement: 'bottom'
                        }
                    },
                    [
                        column.label == '销售总额' ? serviceContent : paymentContent,
                        h('i', {
                            class: 'el-icon-warning-outline',
                            style: 'color:orange;margin-right:5px;'
                        })
                    ]
                ),
                h('span', column.label)
            ]);
        },
        getSummaries(param) {
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = '合计';
                    return;
                }
                const values = data.map(item => Number(item[column.property]));
                if (!values.every(value => isNaN(value))) {
                    sums[index] = values.reduce((prev, curr) => {
                        const value = Number(curr);
                        if (!isNaN(value)) {
                            return prev + curr;
                        } else {
                            return prev;
                        }
                    }, 0);
                    if (index === 3 || index === 6 || index === 8 || index === 9) sums[index] = sums[index].toFixed(2) + ' 元';
                    else sums[index] = sums[index] + '';
                } else {
                    sums[index] = '';
                }
            });

            return sums;
        },
        // 重置表单
        resetSearch() {
            this.$refs.orgCascader.$refs.panel.clearCheckedNodes();
            this.searchData.EntpId = this.searchData.EntpId;
            this.searchData.SId = '';
            this.searchData.SIds = [];
            this.searchData.StartDate = '';
            this.searchData.EndDate = '';
            this.dateTimes = [];
            this.dateFTimes = [];
            this.searchData.PayStartDate = '';
            this.searchData.PayEndDate = '';
        },
        // 获取数据
        getPurchaseTableData() {
            this.$util
                .axiosPost({
                    url: '/api/DataStatistics/PurPerfStat',
                    data: this.searchData
                })
                .then(res => {
                    if (res.errcode != 201) {
                        let data = res.data;
                        this.tablePurchaseData = data;
                        this.tablePurchaseDataLength = res.count;
                    }
                })
                .catch(() => {});
        },
        exportData() {
            let that = this;
            if (that.tablePurchaseData.length == 0) {
                that.$util.warningMsg('请筛选记录');
                return;
            }
            that.showExportMsg = true;
            that.$util
                .exportFile_post({
                    url: '/api/DataStatistics/PurPerfStats_ToExport',
                    data: that.searchData
                })
                .then(res => {
                    that.showExportMsg = false;
                    that.$util.successMsg('导出成功');
                });
        },
        //获取组织树
        getSIdData() {
            if (this.searchData.OrgId) {
                this.$util.getSIdListByOrg(this.searchData.OrgId).then(data => {
                    this.SIdList = data;
                });
            }
        },
        handleChange(val) {
            if (val) {
                this.searchData.StartDate = val[0];
                this.searchData.EndDate = val[1];
            } else {
                this.searchData.StartDate = '';
                this.searchData.EndDate = '';
            }
        },
        handleChangeFinishTime(val) {
            if (val) {
                this.searchData.PayStartDate = val[0];
                this.searchData.PayEndDate = val[1];
            } else {
                this.searchData.PayStartDate = '';
                this.searchData.PayEndDate = '';
            }
        },
        getOrgTree(isShow) {
            if (isShow && this.orgSearchData.length == 0) {
                this.$util
                    .axiosGet({
                        url: '/api/EntpInfoManagement/GetOrgTree'
                    })
                    .then(res => {
                        if (res.data) {
                            this.orgSearchData = this.getTreeData(res.data);
                        }
                    });
            }
        },
        // 数列
        getTreeData(data) {
            for (let i = 0; i < data.length; i++) {
                if (data[i].Childrens.length < 1) {
                    data[i].Childrens = undefined;
                } else {
                    this.getTreeData(data[i].Childrens);
                }
            }
            return data;
        }
    }
};
</script>
<style lang="less" scoped>
.exportmsg {
    display: flex;
    flex-direction: column;
    align-items: center;
    z-index: 10000;
    position: absolute;
    top: 65vh;
    left: 60vh;
    font-size: 22px;
    color: rgb(243, 62, 62);
}
</style>
